export const formatTranslationText = (text: string): string[] => {
    const textToRender = text.split("**");
  
    if (textToRender.length === 1) return [text]
  
    return textToRender
};
  